const disableForm = typeof disableForm !== 'undefined' && disableForm;

function changeState(country) {
  const selectedOption = $('select[name="country"]').find('option:selected');
  const stateDropdown = $('select[name="state"]');
  const stateText = $('input[name="stateInput"]');
  const countryDropdown = $('select[name="country"]');

  if (selectedOption.attr('data-states-count') > 0) {
    if (stateDropdown.is(':visible')) {
      stateDropdown.prop('disabled', true);
    } else if (stateText.is(':visible')) {
      stateText.prop('disabled', true);
    }
    $('.state-loader').show();

    $.get(`${getStatesByCountryUrl}/${selectedOption.attr('value')}`, {

    }, (data) => {
      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        if (!disableForm) stateDropdown.prop('disabled', false);

        $('.state-loader').hide();
        stateText.closest('.form-group').parent().hide();
        stateText.val('');
        const currentState = stateDropdown.val();

        stateDropdown.find('option').remove();
        $.each(data.states, (i, item) => {
          const attr = {
            value: item.code,
            text: item.name
          };
          if (item.code === currentState) {
            attr.selected = 'selected';
          }
          stateDropdown.append($('<option>', attr));
        });
        stateDropdown.closest('.form-group').parent().show();
        stateDropdown.select2({
          placeholder: __('Select State'),
          sorter(data) {
            return data.sort((a, b) => {
              if (a.text > b.text) {
                return 1;
              }
              if (a.text < b.text) {
                return -1;
              }
              return 0;
            });
          }
        });
      }
    }, 'json');
  } else {
    if (!countryDropdown.prop('disabled')) {
      stateText.prop('disabled', false);
    }

    $('.state-loader').hide();
    stateText.closest('.form-group').parent().show();
    stateDropdown.val('');
    stateDropdown.closest('.form-group').parent().hide();
  }
}

jQuery(document).ready(() => {
  const country = $('.select-country').val();
  changeState(country);

  $('.select-denomination').select2({
    placeholder: __('Select Denomination')
  });

  $('.select-state').select2({
    placeholder: __('Select State'),
    sorter(data) {
      return data.sort((a, b) => {
        if (a.text > b.text) {
          return 1;
        }
        if (a.text < b.text) {
          return -1;
        }
        return 0;
      });
    }
  });

  $('.select2-container').on('keypress', function (e) {
    $(this).prev().select2('open');
  });

  $('.select-country').select2({
    placeholder: __('Select Country')
  });

  $('.select-country').on('change', (e) => {
    const country = $('.select-country').val();
    changeState(country);
  });

  $('select[name="timezone"]').select2({
    placeholder: __('Select Timezone')
  });

  $('.select-hymnal').chosen({
    disable_search_threshold: 10,
    placeholder_text: __('Select Worship Resources')
  });
});
